import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../Componets/AdminLayout';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ExamDetails() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate(); // Add this line to access the navigate function
  const location = useLocation(); // Add this line to access the location state
  const { id } = location.state || {};
  const [examDetails, setExamDetails] = useState({ name: '', subjects: [] });
  const [subjectList, setSubjectList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [subjectId, setSubjectId] = useState(''); // Ensure this is updated
  const [questionPaper, setQuestionPaper] = useState(null); // Ensure this is updated
  const [answerKey, setAnswerKey] = useState(null); // Ensure this is updated
  const [qpath, setQpath] = useState(''); // Ensure this is updated
  const [apath, setApath] = useState(''); // Ensure this is updated`
  const [qsnpaper, setQsnpaper] = useState(null); // select qsn paper
  const [asnkey, setAsnkey] = useState(null); // select answer key
  const questionPaperInputRef = useRef(null);
  const answerKeyInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingtable, setLoadingtable] = useState(false);

  // Fetch the exam details and subject list when the component mounts and checks if user is ADMIN
  useEffect(() => {
    setLoadingtable(true);
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }

    const token = localStorage.getItem('token');
    const fetchExamDetails = axios.get(`${apiUrl}/api/exam/${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    Promise.all([fetchExamDetails])
      .then(([examRes, subjectRes]) => {
        setLoadingtable(false);
        setExamDetails({
          name: examRes.data.name,
          subjects: examRes.data.subjects || [],
        });
        setSubjectList(subjectRes.data.subjects || []);
      })
      .catch((err) => {
        setLoadingtable(false);
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });
  }, [apiUrl, id, navigate]);

  const getSubjectNameById = (subjectId) => {
    const subject = subjectList.find((sub) => sub.id === subjectId);
    return subject ? subject.name : 'Unknown';
  };

  const filteredSubjects = examDetails.subjects.filter((subject) =>
    getSubjectNameById(subject.subjectId)
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );
  //show path in modal on click
  const handleButtonClick = async (subjectId) => {
    // Fetch the question paper and answer key paths for the specified subjectId
    const token = localStorage.getItem('token');
    try {
      // Call the API
      const response = await axios.get(`${apiUrl}/api/exam/${id}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      const examData = response.data;

      // Find the subject with the specified subjectId
      const subjects = examData.subjects.find(
        (sub) => sub.subjectId === subjectId
      );

      if (subjects) {
        // Log the questionPaperPath and answerKeyPath
        const questionPaperPath = subjects.questionPaperPath;
        const answerKeyPath = subjects.answerKeyPath;
        const quspath = questionPaperPath.split('/').pop();
        const anspath = answerKeyPath.split('/').pop();
        setQpath(quspath);
        setApath(anspath);
      } else {
        console.log('Subject not found');
      }
    } catch (error) {
      console.error('Error fetching exam data:', error);
      error.response?.status === 401 && navigate('/');
    }
  };
  //clear path in modal
  const handleClear = () => {
    setQpath('');
    setApath('');
    setAnswerKey(null);
    setQuestionPaper(null);
    setQsnpaper(null);
    setAsnkey(null);
  };

  // Define the columns for the table
  const columns = [
    {
      name: 'No.',
      selector: (row, index) => index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Subject Name',
      selector: (row) => row.subjectName,
    },
    {
      name: 'Marks',
      selector: (row) => `${row.totalMarks} / ${row.passingMarks}`,
      center: 'true',
      width: '180px',
    },
    {
      name: 'Internal Marks',
      selector: (row) => `${row.internalTotalMark} / ${row.internalPassMark}`,
      center: 'true',
      width: '180px',
    },
    {
      name: ' Actons',
      center: 'true',
      width: '355px',
      cell: (row) => (
        <div>
          {/* 1 */}
          <button
            onClick={() =>
              navigate('/ListSection', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  subjectname: row.subjectName,
                  examTotalMarks: row.totalMarks - row.omrTotalMark,
                },
              })
            }
            className="btn btn-secondary btn-sm mx-1 "
            data-tooltip-id="my-tooltip"
            data-tooltip-content="List fo Section"
          >
            <i className="bi bi-list-columns"></i>
          </button>
          {/* 2 */}
          <button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Upload Question Paper & Answer Key"
            className="btn btn-primary btn-sm mx-1"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            onClick={() => {
              setSubjectId(row.subjectId); // Set the subjectId here
              handleButtonClick(row.subjectId); // Call the API and log paths
            }}
          >
            <i className="bi bi-cloud-upload"></i>
          </button>
          {/* 3 */}
          <button
            onClick={() =>
              navigate('/WithoutBarcode', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  examname: examDetails.name,
                  subjectname: row.subjectName,
                },
              })
            }
            className="btn btn-primary btn-sm mx-1"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Generate Barcode"
          >
            <i className="bi bi-qr-code-scan"></i>
          </button>
          {/* 4 */}
          <button
            onClick={() =>
              navigate('/AnswerSheetDetails', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  subjectname: row.subjectName,
                  examname: examDetails.name,
                },
              })
            }
            className="btn btn-primary btn-sm mx-1 "
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Upload Answersheet"
          >
            <i className="bi bi-card-list"></i>
          </button>
          {/* 5 */}
          <button
            onClick={() =>
              navigate('/AllocationDetails', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  subjectname: row.subjectName,
                },
              })
            }
            className="btn btn-primary btn-sm mx-1"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="  Answersheet Allocation "
          >
            <i className="bi bi-diagram-3-fill"></i>
          </button>
          {/* 6 */}
          {/* <button onClick={() => navigate('/listmarksmanual', { state: { examId: id, subjectId: row.subjectId,subjectname: getSubjectNameById(row.subjectId) } })} className="btn btn-primary btn-sm mx-1" data-tooltip-id="my-tooltip" data-tooltip-content="Add AnswerSheet Marks ">
                        <i className="bi bi-clipboard2-check"></i>
                    </button> */}
          {/* 7 */}
          <button
            onClick={() =>
              navigate('/sheetTransfer', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  subjectname: row.subjectName,
                },
              })
            }
            className="btn btn-primary btn-sm mx-1"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Answersheet Transfer "
          >
            <i className="bi bi-recycle"></i>
          </button>
          {/* 8 */}
          <button
            onClick={() =>
              navigate('/Result', {
                state: {
                  id: id,
                  subjectId: row.subjectId,
                  subjectname: row.subjectName,
                },
              })
            }
            className="btn btn-primary btn-sm mx-1"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Result"
          >
            <i className="bi bi-clipboard2-data"></i>
          </button>
          <Tooltip id="my-tooltip" />
        </div>
      ),
    },
  ];

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (name === 'questionpaper') {
      setQuestionPaper(files[0]);
      setQsnpaper(files[0].name);
    } else if (name === 'answerkey') {
      setAnswerKey(files[0]);
      setAsnkey(files[0].name);
    }
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const formData = new FormData();
    formData.append('examId', id);
    formData.append('subjectId', subjectId); // Use the dynamic subjectId
    formData.append('questionpaper', questionPaper);
    formData.append('answerkey', answerKey);
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/subject/questionpaperandanswerkey/upload`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    };
    try {
      const response = await axios(config);
      console.log(JSON.stringify(response.data));
      toast.success('Question paper and answer key uploaded successfully');
      setLoading(false);
      setQsnpaper(null);
      setAsnkey(null);
      setAnswerKey(null);
      setQuestionPaper(null);
      closemodel();

      // Reset file input fields
      if (questionPaperInputRef.current) {
        questionPaperInputRef.current.value = '';
      }
      if (answerKeyInputRef.current) {
        answerKeyInputRef.current.value = '';
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response.data.message || error.response.data.errors?.[0]
      );
      setLoading(false);
      error.response?.status === 401 && navigate('/');
    }
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };

  // Function to handle delete answerkey button click
  const deleteanswerkey = () => {
    if (window.confirm('Are you sure you want to delete this Answer Key?')) {
      const token = localStorage.getItem('token');
      const config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/subject/answerkey/${id}/${subjectId}`,
        headers: {
          Authorization: `${token}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          toast.success('Answer key deleted successfully');
          setApath('');
        })
        .catch((error) => {
          console.error(error);
          error.response?.status === 401 && navigate('/');
          toast.error('Answer key not found');
        });
    }
  };
  // Function to handle delete questionpaper button click
  const deletequestionpaper = () => {
    if (
      window.confirm('Are you sure you want to delete this question paper?')
    ) {
      const token = localStorage.getItem('token');
      const config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/subject/questionpaper/${id}/${subjectId}`,
        headers: {
          Authorization: `${token}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          toast.success('Question paper deleted successfully');
          setQpath('');
        })
        .catch((error) => {
          console.error(error);
          error.response?.status === 401 && navigate('/');
          toast.error('Question paper not found');
        });
    }
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/ListExam">View Exam</Link>
              </li>
              <li className="breadcrumb-item active">
                Exam Subjects of ({examDetails.name})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <section className="section col-lg-12">
          <div className="datatable-top">
            <div className="datatable-search">
              <div className="datatable-search">
                <input
                  className="form-control"
                  type="text"
                  name="totalMarks"
                  placeholder="Search"
                  title="Search within table"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div></div>
          </div>
          <DataTable
            columns={columns}
            data={filteredSubjects}
            progressPending={loadingtable}
            className="custom-table"
          />
          <ToastContainer position="top-center" style={{ width: 'auto' }} />
        </section>

        {/* <!-- Modal --> */}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h5
                  className="modal-title text-white p-1 rounded"
                  id="exampleModalLabel"
                >
                  Upload Question Paper & Answer Key ({examDetails.name})
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClear}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit} className="popup-form">
                  <div className="container text-center">
                    <div className="row">
                      <div className="col">
                        <div className="container">
                          <div className="row">
                            {/* Upload Area for Question Paper */}
                            <div className="col">
                              <label className="mb-2">Question Paper</label>
                              <div
                                className="upload-area"
                                onClick={() =>
                                  questionPaperInputRef.current.click()
                                }
                              >
                                <div className="icon">
                                  <img
                                    src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                                    alt="A cat"
                                  />
                                </div>
                                <p className="text">
                                  {' '}
                                  {qsnpaper
                                    ? qsnpaper
                                    : 'Click to upload Question paper'}{' '}
                                </p>
                                <input
                                  className="form-control"
                                  name="questionpaper"
                                  type="file"
                                  id="formFile-question"
                                  onChange={handleFileChange}
                                  accept="application/pdf"
                                  style={{ display: 'none' }}
                                  ref={questionPaperInputRef}
                                />
                                <span>{qpath}</span>
                              </div>
                            </div>

                            {/* Upload Area for Answer Key */}
                            <div className="col">
                              <label className="mb-2">Answer Key</label>
                              <div
                                className="upload-area"
                                onClick={() =>
                                  answerKeyInputRef.current.click()
                                }
                              >
                                <div className="icon">
                                  <img
                                    src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                                    alt="A cat"
                                  />
                                </div>
                                <p className="text">
                                  {asnkey
                                    ? asnkey
                                    : 'Click to upload Answer key'}
                                </p>
                                <input
                                  className="form-control"
                                  name="answerkey"
                                  type="file"
                                  id="formFile-answer"
                                  onChange={handleFileChange}
                                  accept="application/pdf"
                                  style={{ display: 'none' }}
                                  ref={answerKeyInputRef}
                                />
                                <span>{apath}</span>
                              </div>
                            </div>
                            <div className="w-100"></div>
                            <div className="col">
                              <button
                                type="button"
                                className="btn btn-outline-danger mt-3 px-4"
                                onClick={deletequestionpaper}
                              >
                                <i className="bi bi-trash-fill"></i>
                              </button>
                            </div>
                            <div className="col">
                              <button
                                type="button"
                                className="btn btn-outline-danger mt-3 px-4"
                                onClick={deleteanswerkey}
                              >
                                <i className="bi bi-trash-fill"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="modal-footer">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? 'Uploading...' : 'Upload'}
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary mx-1"
                      data-bs-dismiss="modal"
                      onClick={handleClear}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/*   this is for path for answer key */}
    </AdminLayout>
  );
}
